import { render } from "./list-management-modal-item.vue?vue&type=template&id=96785728&scoped=true&ts=true"
import script from "./list-management-modal-item.vue?vue&type=script&lang=ts"
export * from "./list-management-modal-item.vue?vue&type=script&lang=ts"

import "./list-management-modal-item.vue?vue&type=style&index=0&id=96785728&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96785728"]])

export default __exports__